import { baseAuthModel } from '../authModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = baseAuthModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '账户/名称',
            fieldName: 'accountName',
            span: 3,
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: '名称',
        //     fieldName: 'name',
        //     span: 3,
        // },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
